import { render, staticRenderFns } from "./tourist-three.vue?vue&type=template&id=23ea15e6&scoped=true"
import script from "./tourist-three.vue?vue&type=script&lang=js"
export * from "./tourist-three.vue?vue&type=script&lang=js"
import style0 from "./tourist-three.vue?vue&type=style&index=0&id=23ea15e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_d79148f6156699cf80ef22aa45ce0a5c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea15e6",
  null
  
)

export default component.exports